import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { PageHandlerService } from './page-handler.service';
import { BasePage } from 'src/app/core/interfaces';

export const pageResolver: ResolveFn<BasePage | null> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(PageHandlerService).getPage(route);
};
